// Centralized tier-access derivation. `plan_tier` is an untyped string on the wire
// (free | pro | all_access); this is the single typed surface for gating + copy.
export type PlanTier = "free" | "pro" | "all_access";

export interface TierAccess {
  tier: PlanTier;
  isFree: boolean;
  isPro: boolean;
  isAllAccess: boolean;
  /** The 7 products are All-Access-only (Pro = coach power-ups, not products). */
  canAccessProducts: boolean;
  /** Coach power-ups: Forge Coach, unlimited evals — Pro or All-Access. */
  canAccessCoach: boolean;
  /** Internal moderator override. Surfaced separately; sites combine `|| isModerator`
   *  exactly where they did before, so migration is behavior-preserving. */
  isModerator: boolean;
}

export function getTierAccess(
  user: { plan_tier?: string | null; is_moderator?: boolean | null } | null | undefined,
): TierAccess {
  const tier: PlanTier =
    user?.plan_tier === "all_access" || user?.plan_tier === "pro" ? user.plan_tier : "free";
  const isAllAccess = tier === "all_access";
  const isPro = tier === "pro";
  return {
    tier,
    isFree: tier === "free",
    isPro,
    isAllAccess,
    canAccessProducts: isAllAccess,
    canAccessCoach: isPro || isAllAccess,
    isModerator: !!user?.is_moderator,
  };
}
